export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00867.82c76a17.png";